export const api = {
  modules: '/modules',
  modulesList: '/modules-list',
  operations: '/operations-list',
  rolesGroup: '/role-groups',
  roles: '/roles',
  masters: '/masters',
  mastersData: '/master-data',
  userPrivileges: '/user-privileges',
  staff: '/staff',
  usersList: '/users-list',
  userLocations: '/user-locations',
  stateList: '/states-list',
  cityList: '/cities',
  stockLocationList: '/stock-location-list',
  zone: '/zone',
  zoneList: '/zone-list',
  tax: '/tax',
  taxList: '/tax-list',
  deliveryCharge: '/delivery-charge',
  deliveryChargeList: '/delivery-charge-list',
  reportConfigsList: '/report-publish-config-list',
  reportConfig: '/report-publish-config',
  attachReportsToRole: '/roles/attach-reports',
  membershipRole: '/membership-role',
  enrollmentTypeByCondition: '/enrollment-types/condition/',
  department: '/department',
  locations: '/locations',
  currencies: '/currencies',
  currenciesConversion: '/currencies-conversions-list',
  currenciesConversionPost: '/currencies-conversions',
}
